/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import moment from 'moment';

const guessClientTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

const getClientDate = (timeZone = null) => new Date().toLocaleString('en-US', {
    timeZone: timeZone || guessClientTimeZone(),
});

const isPast = (firstDate, secondDate) => moment(firstDate).isBefore(secondDate, 'day');

export { getClientDate, isPast };
